import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  inject
} from '@angular/core';
import {FormFieldComponent} from '../../../shared/components/form-field/form-field.component';
import {TemplateModel} from '../../../shared/model/template/template-model';
import {SelectOneComponent} from '../../../shared/components/select-one/select-one.component';
import {CodigoIdiomaEnum} from '../../../shared/enum/codigo-idioma-enum';
import {SlideTogglePadraoComponent} from '../../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {TextoMidiaEnum} from '../../../shared/enum/texto-midia-enum';
import {MatIcon} from '@angular/material/icon';
import {FormsModule} from '@angular/forms';
import {TemplateVariavel} from '../../../shared/model/template/template-variavel-model';
import {ButtonPadraoComponent} from '../../../shared/components/button-padrao/button-padrao.component';
import {TemplateBotaoModel} from '../../../shared/model/template/template-botao-model';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {TemplateMidiaEscolhaComponent} from '../template-midia-escolha/template-midia-escolha.component';
import {DomSanitizer} from '@angular/platform-browser';
import {PrototipoTemplateComponent} from '../prototipo-template/prototipo-template.component';
import {TemplateCabecalhoModel} from '../../../shared/model/template/template-cabecalho-model';
import {Conta} from '../../../shared/model/conta.model';
import {ContaService} from '../../../shared/service/conta.service';
import {CelularMaskPipe} from '../../../shared/pipe/celular-mask.pipe';
import {ValidacaoAlteracaoCampoService} from '../../../shared/service/utilitarios/validacao-alteracao-campo.service';
import {AuthService} from '../../../shared/service/auth.service';
import {UsuarioService} from '../../../shared/service/usuario.service';
import {calcularSMS, CalculoSms, removerAcentos} from '../../../shared/util/sms.utils';

@Component({
  selector: 'app-interacao-marketing',
  standalone: true,
  imports: [
    FormFieldComponent,
    SelectOneComponent,
    SlideTogglePadraoComponent,
    MatIcon,
    FormsModule,
    ButtonPadraoComponent,
    MatButtonToggleModule,
    TemplateMidiaEscolhaComponent,
    PrototipoTemplateComponent,
    CelularMaskPipe
  ],
  templateUrl: './interacao-marketing.component.html',
  styleUrl: './interacao-marketing.component.css'
})
export class InteracaoMarketingComponent implements OnInit, OnChanges, AfterViewInit {
  public readonly sanitizer = inject(DomSanitizer);
  private readonly contaService = inject(ContaService);
  public readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly authService = inject(AuthService);

  @ViewChild('editor') editorRef!: ElementRef<HTMLDivElement>;

  @Input() template: TemplateModel = new TemplateModel();
  @Input() tipo = 'WHATSAPP';
  @Input() visualizar?: boolean;
  @Input() edicao = false;
  @Output() envioTemplate = new EventEmitter<TemplateModel>();

  get isSms(): boolean {
    return (this.tipo || '').toUpperCase() === 'SMS';
  }

  cabecalhoExibido = false;
  rodapeExibido = false;
  botaoExibido = false;

  urlOriginal?: string;
  phoneOriginal?: string

  conteudoBotaoMaisVinteCaracteres = false;

  msgFinalConstruida = '';
  setorUsuarioLogado? : number;

  listaIdiomas = Object.entries(CodigoIdiomaEnum).map(([key, value]) => ({
    label: key,
    value: value
  }));

  contas: Conta[] = [];

  readonly opcoesTipoVariavelFixa: { valor: string; label: string }[] = [
    { valor: 'CONTATO_NOME', label: 'Nome do contato' },
    { valor: 'CONTATO_NUMERO', label: 'Número do contato' },
    { valor: 'OPERADOR_NOME', label: 'Nome do operador' },
  ];

  ngOnInit() {
    this.buscarSetorUsuario();
    this.verificarPodeAbrirSecoes();
    this.alteracaoService.camposNaoAlterados();
    if (!this.edicao) {
      this.template.ativo = true;
    }

    this.template.botoes.forEach(btn => {
      if(btn.url){
        this.urlOriginal = btn.url;
      } else if (btn.phone_number){
        this.phoneOriginal = btn.phone_number;
      }
    })
  }

  ngOnChanges() {
    this.envioTemplate.emit(this.template);
  }

  ngAfterViewInit() {
    if (!this.editorRef) {
      return;
    }
    const corpo = this.isSms ? removerAcentos(this.template.variavel.corpo) : this.template.variavel.corpo;
    this.template.variavel.corpo = corpo;
    this.editorRef.nativeElement.innerText = corpo;
  }

  verificarInteracaoBotaoUrl(atual: string){
    if (atual !== this.urlOriginal) {
      this.alteracaoService.camposAlterado();
    }
  }
  verificarInteracaoBotaoPhone(atual: string){
    if (atual !== this.phoneOriginal) {
      this.alteracaoService.camposAlterado();
    }
  }

  verificarPodeAbrirSecoes(){
    if(this.edicao){
      this.cabecalhoExibido = true;
      this.rodapeExibido = true;
      this.botaoExibido = true;
    }
  }

  receberTitulo(event: string){
    this.template.nome = event.replace(' ', '_').toLowerCase();
  }

  buscarNumeros(usuario?: any) {
    if (!this.setorUsuarioLogado) return;

    const visualizaTodos = usuario?.perfil?.restricoes?.some(
      (r: any) => r.chave === 'VISUALIZAR_TODOS_NUMEROS');

    if (visualizaTodos) {
      this.contaService.buscarTodosNumerosAtivos().subscribe({
        next: res => this.contas = res
      });
    } else {
      this.contaService.buscarNumerosPorSetor(this.setorUsuarioLogado).subscribe({
        next: res => this.contas = res
      });
    }
  }

  limparCabecalho(){
    this.template.templateCabecalho = new TemplateCabecalhoModel();
  }

  limparRodape(){
    this.template.textoRodape = undefined;
  }

  limparBotao(index: number){
    this.template.botoes.splice(index, 1);
  }


  onInputEditor() {
    if (this.isSms) {
      this.removerAcentosDoEditor();
    }
    const html = this.editorRef.nativeElement.innerHTML;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const spans = tempDiv.querySelectorAll('span');
    spans.forEach(span => {
      const textNode = document.createTextNode(span.innerText);
      span.parentNode?.replaceChild(textNode, span);
    });

    const textoFinal = tempDiv.innerHTML
      .replace(/<div><br><\/div>/g, '\n')
      .replace(/<div>/g, '\n')
      .replace(/<\/div>/g, '')
      .replace(/<br\s*\/?>/g, '\n')
      .replace(/&nbsp;/g, ' ')
      .replace(/<[^>]*>/g, '');

    this.pegarCorpoVariavel(textoFinal);
  }



  pegarCorpoVariavel(corpo: string) {
    if (this.isSms) {
      corpo = removerAcentos(corpo);
    }
    const regex = /\{\{\d+\}\}/g;
    const corpoAnterior = this.template.variavel.corpo || '';
    const tokensAnteriores = corpoAnterior.match(regex) || [];
    const numerosRemovidos: number[] = [];

    for (const token of tokensAnteriores) {
      const numero = token.match(/\d+/)?.[0];
      if (!numero) continue;

      if (!corpo.includes(token)) {
        const fragmentoRegex = new RegExp(`\\{?\\{?[^\\d{]*${numero}[^\\d}]*\\}?\\}?`, 'g');
        corpo = corpo.replace(fragmentoRegex, '');
        numerosRemovidos.push(Number(numero));
      }
    }


    corpo = corpo.replace(/[ ]{2,}/g, ' ').trim();

    numerosRemovidos.reverse().forEach(num => this.removerVariavel(num - 1));
    this.template.variavel.corpo = corpo;
  }



  bloquearChaves(event: KeyboardEvent){
    if (event.key === '{' || event.key === '}') {
      event.preventDefault();
    }
  }

  removerVariavel(index: number){
    this.template.variavel.variaveis.splice(index, 1);
  }

  adicionarViariavel(){
    const novaVariavel = new TemplateVariavel();
    novaVariavel.numero = this.template.variavel.variaveis.length + 1;
    novaVariavel.variavel = '';

    this.template.variavel.variaveis.push(novaVariavel);
    this.template.variavel.corpo = this.template.variavel.corpo + ` {{${novaVariavel.numero}}}`;

    const html = `<span style="color: var(--primary); font-weight: 700;">{{${novaVariavel.numero}}}</span>`;
    this.inserirVariavelNoCursor(html);
  }

  inserirVariavelNoCursor(html: string) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    range.deleteContents();

    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;

    const fragment = document.createDocumentFragment();
    let lastNode: Node | null = null;

    while (tempElement.firstChild) {
      lastNode = fragment.appendChild(tempElement.firstChild);
    }

    const space = document.createTextNode('\u00A0');
    fragment.appendChild(space);
    lastNode = space;

    range.insertNode(fragment);

    if (lastNode) {
      range.setStartAfter(lastNode);
      range.collapse(true);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  adicionarBotao(){
    const btn = new TemplateBotaoModel();
    btn.type = 'QUICK_REPLY';
    btn.text = '';

    this.template.botoes.push(btn);
  }

  pegarConteudoBotao(txt: string, btn: TemplateBotaoModel){
    btn.text = txt;
    if(btn.text!.length === 20){
      this.conteudoBotaoMaisVinteCaracteres = true;
    } else {
       this.conteudoBotaoMaisVinteCaracteres = false;
    }
  }

  criarPlaceholder(btn: TemplateBotaoModel): string{
    if(btn.type === 'QUICK_REPLY'){
      return 'Resposta';
    } else if(btn.type === 'URL'){
      return 'digite a url';
    } else if(btn.type === 'PHONE_NUMBER'){
      return '(__)_____-____';
    }
    return '';
  }

  montarTextoMensagem(): string {
    const variaveis = this.template.variavel.variaveis;

    this.msgFinalConstruida = this.template.variavel.corpo.replace(/\{\{(\d+)\}\}/g, (_, numero) => {
      const pos = parseInt(numero) - 1;
      const valor = variaveis[pos]?.variavel ?? '';
      return valor;
    });

    return this.msgFinalConstruida;
  }

  get calculoSms(): CalculoSms {
    const variaveis = this.template.variavel.variaveis;
    const mensagem = this.template.variavel.corpo.replace(/\{\{(\d+)\}\}/g, (_, numero) => {
      return variaveis[Number(numero) - 1]?.variavel ?? '';
    });
    return calcularSMS(removerAcentos(mensagem));
  }

  receberExemploVariavel(valor: string, variavel: TemplateVariavel): void {
    variavel.variavel = this.isSms ? removerAcentos(valor) : valor;
    this.msgFinalConstruida = variavel.variavel;
  }

  private readonly exemploPadraoPorTipoFixo: Record<string, string> = {
    CONTATO_NOME: 'João da Silva',
    CONTATO_NUMERO: '5511999999999',
    OPERADOR_NOME: 'Maria',
  };

  opcaoTipoVariavelFixa(variavel: TemplateVariavel) {
    return this.opcoesTipoVariavelFixa.find(o => o.valor === variavel.tipoCampoFixo);
  }

  definirTipoVariavelFixa(variavel: TemplateVariavel, opcao: { valor: string; label: string }): void {
    variavel.tipoCampoFixo = opcao.valor;
    variavel.variavel = this.exemploPadraoPorTipoFixo[opcao.valor] ?? '';
  }

  alterarVariavelFixa(valor: boolean): void {
    this.template.variavelFixa = valor;
    if (!valor) {
      this.template.variavel.variaveis.forEach(v => v.tipoCampoFixo = undefined);
    }
    this.alteracaoService.camposAlterado();
  }

  private removerAcentosDoEditor(): void {
    const editor = this.editorRef.nativeElement;
    const selecao = window.getSelection();
    const ancora = selecao?.anchorNode ?? null;
    const foco = selecao?.focusNode ?? null;
    const deslocamentoAncora = selecao?.anchorOffset ?? 0;
    const deslocamentoFoco = selecao?.focusOffset ?? 0;
    let alterouConteudo = false;

    const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
    let atual = walker.nextNode();
    while (atual) {
      const textoAtual = atual.textContent ?? '';
      const textoSemAcentos = removerAcentos(textoAtual);
      if (textoAtual !== textoSemAcentos) {
        atual.textContent = textoSemAcentos;
        alterouConteudo = true;
      }
      atual = walker.nextNode();
    }

    if (alterouConteudo && selecao && ancora && foco && editor.contains(ancora) && editor.contains(foco)) {
      selecao.setBaseAndExtent(
        ancora,
        Math.min(deslocamentoAncora, ancora.textContent?.length ?? 0),
        foco,
        Math.min(deslocamentoFoco, foco.textContent?.length ?? 0)
      );
    }
  }



  buscarArquivoCabecalho(file: any){
    const objectURL = URL.createObjectURL(file.file);
    this.template.templateCabecalho.file = file.base64;
    this.template.templateCabecalho.blob = this.sanitizer.bypassSecurityTrustResourceUrl(objectURL);
  }

  buscarSetorUsuario() {
    this.usuarioService.buscarUsuarioComplete(this.authService.getUsuarioLogado().id!).subscribe({
      next: data => {
        this.setorUsuarioLogado = data.setorDTO?.id
        this.buscarNumeros(data);
      }
    })
  }

  settarIdioma(event: any){
    this.template.idioma = event;
    this.template.idiomaAuxString = event.label;
  }

  protected readonly TextoMidiaEnum = TextoMidiaEnum;
  protected readonly console = console;
  protected readonly Date = Date;
  protected readonly Object = Object;
}
